import React, { Component } from 'react';
import FaArrowRight from 'react-icons/lib/fa/arrow-right';

class Userguide extends Component {
  constructor(props){
    super(props);
    this.goBack = this.goBack.bind(this);
  }

  goBack(){
      this.props.history.goBack();
  }

  render() {
    return (
  <div>
  <div id="header">
    <h2 className="header-title">Chirosystem</h2>
    <button type='button' className="logout-button" onClick={this.goBack}>Go Back <FaArrowRight /></button>
  </div>
  <div align="center" className="container-userguide">
  <h1>User Guide</h1>
  </div>
  <div align="center" className="container-userguide">
      <p>

1 – the software is designed to work with pc and\or tablet
I recommend using a tablet 7 inch is sufficient.
You can place a Tablet at each table.
I suggest setting the tablet sleep mode Off so the tablet's screen will be on continuously so you do not have to deal with turning On the screen. You can work with one tablet using mulitple window tabs.</p>
<p>2- Once you logged in you ready to start!</p>
<p>3- You need to enter PM first and second name and press 'Create a New Patient'
If you have a duplicate PM name the system will warn you so just add another letter to the PM name (e.g david david a)
      </p>
      <div>
      <img src={require('./userguide/newpaitent.png')}/>
      </div>
      </div>
      <div className="container-userguide" align="center">
        <p>
        5 – Press the 'Main' button to enter the working area.</p>
<p>6- Type in the First or/ Last name and a list of PM with that First or/ Last name will open. You can also type in only one letter from the PM name and a list with all the names that contain this letter will open after clicking 'Search'.
        </p>
        <div>
        <img src={require('./userguide/searchuser.png')}/>
        </div>
        <div>
        <img src={require('./userguide/aftersearch.png')}/>
        </div>
      </div>
      <div align="center" className="container-userguide">
        <p>
        7- After you choose the desired PM you will reach this PM main File,
Press on the menu button and a list of all the analysis and parameters will open. You can delete parts that you are not working with. Click on the list, then click YES, then click at the main working area.</p>
<p>8- You can add a photo. If using a tablet it will ask you to use the tablet's camera. Take the photo and click save. To see the photo refresh the page.</p>
<p>9- If you wish to upload a photo of the written consultation. Do the same with 'Add File'.</p>
<p>10- The analysis part is on top. Start recording parameters. They can be changed.</p>
<div>
        <img src={require('./userguide/maincontent.png')}/>
        </div>
        <p>11- For Passive active subsystem you can mark it with the appropriate colors
  The right column BRT is to record braeth.</p>
      </div>
      <div className="container-userguide" align="center">
      <p>12- To record entrainments
      Start with the intelligence B = 'bio' E = 'emotional' LM = 'lower mental' UP = 'upper mental' SL = 'soul'
      Than choose PHASE, than click the GW (only the appropriate GW will be highlighted) and hit 'Submit Buttons'. The entrainment will be recorded at the buttom of the page with the appropriate date. If using PHASE 1 Just click P1 and the appropriate sacral GW and hit 'Submit Buttons'.</p>
      <div>
      <img src={require('./userguide/history.png')}/>
      </div>
    </div>
    <div className="container-userguide" align="center">
    <p>12- Double click on the GW and window will open with all the contacts and level of contacts taken on that GW</p>
    <div>
    <img src={require('./userguide/statistics.png')}/>
    </div>
    <p>13- If using integrate choose the intelligence in the order (the entrainment will be recorded in that order).</p>
    <div>
    <img src={require('./userguide/final.png')}/>
    </div>
    </div>
  </div>
    );
  }
}

export default Userguide;



// WEBPACK FOOTER //
// ./src/routes/Userguide.js